import { gql } from "apollo-boost";

export const SPECIALITIES_BY_CONSULTORY_PARAMETERS = gql`
  query consultoryParameters(
    $where: ConsultoryParametersInput
    $relations: [String]
  ) {
    consultoryParameters(where: $where, relations: $relations) {
      specialty {
        id
        name
      }
    }
  }
`;

export const CONSULTORY_PARAMETERS_AND_ORDER = gql`
  query consultoryParametersAndOrder($where: ConsultoryParametersInput) {
    consultoryParametersAndOrder(where: $where) {
      id
      amountConfiguration
      medicalParameterGroupId
      nameParameterGroup
      order
    }
  }
`;

export const VALIDATE_USE_SPECIALITIES_IN_PARAMETERS = gql`
  query validateUseSpecialitiesInParameters($where: ConsultoryParametersInput) {
    validateUseSpecialitiesInParameters(where: $where)
  }
`;
